module.exports = __webpack_public_path__ + "static/media/rolletexpl2.6ceb8163.jpg";